define('TescoMobile_Eocn/js/view/recommendations',['jquery', 'ko', 'uiComponent', 'Magento_Customer/js/customer-data', 'Magento_Catalog/js/price-utils', 'catalogAddToCart', 'jquery/slick', 'jquery/match-height'], function ($, ko, Component, customerData, priceUtils) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Eocn/recommendations',
      itemTemplate: 'TescoMobile_Eocn/item',
      extensionFields: [],
      extensionTemplates: [],
      title: 'Recommended deals',
      recommendationContainerSelector: '.eoc-recommendations',
      monthlyDealsUrl: '#',
      visible: false,
      formKey: $.mage.cookies.get('form_key'),
      items: [],
      countItems: 0
    },
    initialize: function () {
      this._super();
      customerData.reload(['eocn'], false);
    },
    initObservable: function () {
      return this._super().observe('visible formKey items countItems');
    },
    updateItems: function (data) {
      if (data !== null && data !== void 0 && data.items) {
        this.items(data.items);
        this.countItems(0);
      }
      this.visible(this.items().length > 0);
    },
    loadRecommendations: function () {
      const recommendations = customerData.get('eocn');
      recommendations.subscribe(this.updateItems, this);
    },
    getFormattedPrice: function (price) {
      const priceFormat = {
        decimalSymbol: '.',
        integerRequired: false,
        pattern: "£%s",
        precision: 2,
        requiredPrecision: 2
      };
      return priceUtils.formatPrice(price, priceFormat);
    },
    initAddToCart: function () {
      $(this.recommendationContainerSelector + ' form[data-role="tocart-form"]').submit(function (event) {
        event.preventDefault();
        const form = $(this).catalogAddToCart({
          bindSubmit: false
        });
        $('body').trigger('add-to-cart-upgrade');
        form.catalogAddToCart('ajaxSubmit', form);
      });
    },
    initShowPromoDialog: function () {
      $(this.recommendationContainerSelector + ' .product-item-promo').click(function () {
        const content = $(this).find('.product-item-dialog');
        content.css('margin-top', -content.outerHeight() - $(this).outerHeight()).toggle();
      });
    },
    afterRenderItems: function () {
      let count = this.countItems() + 1;
      this.countItems(count);
      if (this.countItems() === this.items().length) {
        this.initSlider();
      }
    },
    initSlider: function () {
      let self = this;
      const sliderId = $('.eoc-recommendations .product-items');
      const productItemWrapper = $('.product-item .result-content');
      sliderId.on('init', function (event, slick) {
        productItemWrapper.matchHeight();
        self.initShowPromoDialog();
        self.initAddToCart();
      });
      sliderId.on("beforeChange", function () {
        productItemWrapper.matchHeight();
      });
      sliderId.on("breakpoint", function () {
        productItemWrapper.matchHeight();
        self.initShowPromoDialog();
        self.initAddToCart();
      });
      sliderId.slick({
        "mobileFirst": true,
        "arrows": true,
        "dots": false,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "infinite": false,
        "responsive": [{
          "breakpoint": 580,
          "settings": {
            "slidesToShow": 2,
            "slidesToScroll": 1,
            "arrows": true,
            "dots": false
          }
        }, {
          "breakpoint": 1150,
          "settings": {
            "slidesToShow": 3,
            "slidesToScroll": 1,
            "arrows": true,
            "dots": false
          }
        }]
      });
      window.addEventListener('resize', productItemWrapper.matchHeight(), false);
      window.addEventListener('orientationchange', productItemWrapper.matchHeight());
    }
  });
});

